var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBaseballBat = function SvgBaseballBat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m5.432 20.689-2.121-2.121a1.5 1.5 0 0 0-2.122 2.121l2.122 2.122a1.5 1.5 0 0 0 2.121-2.122"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M3.311 18.568S15.384 3.313 16.848 1.848a3.75 3.75 0 0 1 5.3 5.3C20.687 8.616 5.432 20.689 5.432 20.689zm7.624-2.254-3.249-3.249m-2.124 2.666 2.707 2.707"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 20.25,
    cy: 20.25,
    r: 3
  }))));
};
export default SvgBaseballBat;